/**
 * Mock documents for dev / mock-mode. ~10 documents across categories and
 * statuses; several are linked to seeded mock customers (`cust-001`..`cust-003`)
 * via `linkedEntityType: 'customer'` so the customer Documents tab has data.
 *
 * Shared by TASK-03 (Documents centre) and TASK-01a (customer Documents tab).
 */

import type { Document } from '@/types/document.types'

export const mockDocuments: Document[] = [
  {
    id: 'doc-001',
    name: 'PAN_Card_Rajesh.pdf',
    description: 'Self-attested PAN card copy',
    filePath: '/tenant/documents/doc-001.pdf',
    fileSize: 245_760,
    fileType: 'pdf',
    mimeType: 'application/pdf',
    fileSizeMb: 0.23,
    category: 'pan_card',
    status: 'verified',
    accessLevel: 'team',
    tags: ['identity'],
    linkedEntityType: 'customer',
    linkedEntityId: 'cust-001',
    isVerified: true,
    verifiedByName: 'Rajesh Kumar',
    verifiedAt: '2025-06-02T10:15:00Z',
    version: 1,
    isLatest: true,
    createdByName: 'Priya Sharma',
    createdAt: '2025-06-01T09:00:00Z',
    updatedAt: '2025-06-02T10:15:00Z',
  },
  {
    id: 'doc-002',
    name: 'Form_16_FY2024-25.pdf',
    description: 'Employer Form 16 for AY 2025-26',
    filePath: '/tenant/documents/doc-002.pdf',
    fileSize: 1_048_576,
    fileType: 'pdf',
    mimeType: 'application/pdf',
    fileSizeMb: 1.0,
    category: 'form_16',
    status: 'uploaded',
    accessLevel: 'team',
    tags: ['income', 'fy2024-25'],
    linkedEntityType: 'customer',
    linkedEntityId: 'cust-001',
    isVerified: false,
    version: 1,
    isLatest: true,
    createdByName: 'Priya Sharma',
    createdAt: '2025-06-04T14:30:00Z',
    updatedAt: '2025-06-04T14:30:00Z',
  },
  {
    id: 'doc-003',
    name: 'Bank_Statement_HDFC_Q1.pdf',
    description: 'HDFC savings account, Apr–Jun 2025',
    filePath: '/tenant/documents/doc-003.pdf',
    fileSize: 2_359_296,
    fileType: 'pdf',
    mimeType: 'application/pdf',
    fileSizeMb: 2.25,
    category: 'bank_statement',
    status: 'processing',
    accessLevel: 'team',
    tags: ['bank'],
    linkedEntityType: 'customer',
    linkedEntityId: 'cust-002',
    isVerified: false,
    version: 1,
    isLatest: true,
    createdByName: 'Amit Patel',
    createdAt: '2025-06-05T11:20:00Z',
    updatedAt: '2025-06-06T08:00:00Z',
  },
  {
    id: 'doc-004',
    name: 'Aadhaar_Card_Sunita.jpg',
    description: 'Aadhaar front and back',
    filePath: '/tenant/documents/doc-004.jpg',
    fileSize: 512_000,
    fileType: 'jpg',
    mimeType: 'image/jpeg',
    fileSizeMb: 0.49,
    category: 'aadhaar_card',
    status: 'verified',
    accessLevel: 'private',
    tags: ['identity'],
    linkedEntityType: 'customer',
    linkedEntityId: 'cust-002',
    isVerified: true,
    verifiedByName: 'Amit Patel',
    verifiedAt: '2025-05-28T16:45:00Z',
    version: 2,
    isLatest: true,
    parentDocumentId: 'doc-004-v1',
    createdByName: 'Amit Patel',
    createdAt: '2025-05-27T10:00:00Z',
    updatedAt: '2025-05-28T16:45:00Z',
  },
  {
    id: 'doc-005',
    name: 'Investment_Proof_ELSS.pdf',
    description: 'ELSS statement for 80C deduction',
    filePath: '/tenant/documents/doc-005.pdf',
    fileSize: 327_680,
    fileType: 'pdf',
    mimeType: 'application/pdf',
    fileSizeMb: 0.31,
    category: 'investment_proof',
    status: 'uploaded',
    accessLevel: 'team',
    tags: ['80c', 'investment'],
    linkedEntityType: 'customer',
    linkedEntityId: 'cust-003',
    isVerified: false,
    version: 1,
    isLatest: true,
    createdByName: 'Neha Gupta',
    createdAt: '2025-06-07T13:10:00Z',
    updatedAt: '2025-06-07T13:10:00Z',
  },
  {
    id: 'doc-006',
    name: 'ITR_Acknowledgement_AY2024-25.pdf',
    description: 'ITR-1 acknowledgement, AY 2024-25',
    filePath: '/tenant/documents/doc-006.pdf',
    fileSize: 184_320,
    fileType: 'pdf',
    mimeType: 'application/pdf',
    fileSizeMb: 0.18,
    category: 'itr_acknowledgement',
    status: 'verified',
    accessLevel: 'client',
    tags: ['itr', 'ay2024-25'],
    linkedEntityType: 'customer',
    linkedEntityId: 'cust-003',
    isVerified: true,
    verifiedByName: 'Neha Gupta',
    verifiedAt: '2025-04-30T09:30:00Z',
    version: 1,
    isLatest: true,
    createdByName: 'Neha Gupta',
    createdAt: '2025-04-29T17:00:00Z',
    updatedAt: '2025-04-30T09:30:00Z',
  },
  {
    id: 'doc-007',
    name: 'Demand_Notice_143_1.pdf',
    description: 'Intimation under section 143(1)',
    filePath: '/tenant/documents/doc-007.pdf',
    fileSize: 98_304,
    fileType: 'pdf',
    mimeType: 'application/pdf',
    fileSizeMb: 0.09,
    category: 'demand_notice',
    status: 'rejected',
    accessLevel: 'team',
    tags: ['notice'],
    linkedEntityType: 'customer',
    linkedEntityId: 'cust-001',
    isVerified: false,
    verificationNotes: 'Illegible scan — request a clearer copy.',
    version: 1,
    isLatest: true,
    createdByName: 'Priya Sharma',
    createdAt: '2025-06-08T12:00:00Z',
    updatedAt: '2025-06-08T15:20:00Z',
  },
  {
    id: 'doc-008',
    name: 'Salary_Slip_March2025.pdf',
    description: 'March 2025 salary slip',
    filePath: '/tenant/documents/doc-008.pdf',
    fileSize: 76_800,
    fileType: 'pdf',
    mimeType: 'application/pdf',
    fileSizeMb: 0.07,
    category: 'salary_slip',
    status: 'uploaded',
    accessLevel: 'team',
    tags: ['income'],
    linkedEntityType: 'customer',
    linkedEntityId: 'cust-002',
    isVerified: false,
    version: 1,
    isLatest: true,
    createdByName: 'Amit Patel',
    createdAt: '2025-06-09T10:45:00Z',
    updatedAt: '2025-06-09T10:45:00Z',
  },
  {
    id: 'doc-009',
    name: 'Old_Audit_Report_FY2021-22.pdf',
    description: 'Archived statutory audit report',
    filePath: '/tenant/documents/doc-009.pdf',
    fileSize: 4_194_304,
    fileType: 'pdf',
    mimeType: 'application/pdf',
    fileSizeMb: 4.0,
    category: 'audit_report',
    status: 'archived',
    accessLevel: 'team',
    tags: ['audit', 'fy2021-22'],
    isVerified: true,
    verifiedByName: 'Rajesh Kumar',
    verifiedAt: '2022-09-15T11:00:00Z',
    version: 1,
    isLatest: true,
    createdByName: 'Rajesh Kumar',
    createdAt: '2022-09-10T09:00:00Z',
    updatedAt: '2023-01-02T09:00:00Z',
  },
  {
    id: 'doc-010',
    name: 'Property_Deed_Bangalore.pdf',
    description: 'Sale deed — residential property',
    filePath: '/tenant/documents/doc-010.pdf',
    fileSize: 6_291_456,
    fileType: 'pdf',
    mimeType: 'application/pdf',
    fileSizeMb: 6.0,
    category: 'property_deed',
    status: 'pending',
    accessLevel: 'private',
    tags: ['property'],
    isVerified: false,
    version: 1,
    isLatest: true,
    createdByName: 'Priya Sharma',
    createdAt: '2025-06-10T08:30:00Z',
    updatedAt: '2025-06-10T08:30:00Z',
  },
]
